import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { QuickDeckGame } from './QuickDeckGame';
import { FEATURE_FLAGS } from './config';

/**
 * QuickDeckFAB - Floating Action Button to launch Instant Pulse
 * Simple, one-tap access to the gamified Instant Pulse experience
 */
export function QuickDeckFAB({ onScanHere, onAudioGuide }) {
  const [isOpen, setIsOpen] = useState(false);

  if (!FEATURE_FLAGS.quickdeck) return null;

  return (
    <>
      {/* FAB Button */}
      <AnimatePresence>
        {!isOpen && (
          <motion.button
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setIsOpen(true)}
            className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40 w-14 h-14 md:w-16 md:h-16 rounded-full bg-gradient-to-r from-purple-600 to-pink-500 text-white shadow-2xl shadow-purple-500/40 flex items-center justify-center group"
            data-testid="instant-pulse-fab"
          >
            <Sparkles className="w-6 h-6 md:w-7 md:h-7 group-hover:rotate-12 transition-transform" />
            
            {/* Pulse ring */}
            <span className="absolute inset-0 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 animate-ping opacity-30" />
            
            {/* Tooltip */}
            <span className="absolute -top-12 left-1/2 -translate-x-1/2 px-3 py-1.5 bg-gray-900 text-white text-xs font-medium rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
              Instant Pulse
              <span className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900" />
            </span>
          </motion.button>
        )}
      </AnimatePresence>

      {/* Instant Pulse Game Modal */}
      <AnimatePresence>
        {isOpen && (
          <QuickDeckGame 
            onScanHere={() => {
              setIsOpen(false);
              onScanHere?.();
            }}
            onAudioGuide={(result) => {
              setIsOpen(false);
              onAudioGuide?.(result);
            }}
            onClose={() => setIsOpen(false)}
          />
        )}
      </AnimatePresence>
    </>
  );
}

export default QuickDeckFAB;
